import type { StandardServicePageContent } from "~/content/servicePage";

export const PhotovoltaicInspectionContent: StandardServicePageContent = {
  heroTitle: "Przegląd instalacji fotowoltaicznej",
  quickFactsTitle: "Najważniejsze informacje w skrócie",
  quickFacts: [
    {
      label: "Jak często",
      value: "Zalecane co 1-2 lata",
      description:
        "Stan instalacji PV powinien też być uwzględniany w obowiązkowej kontroli instalacji elektrycznej wykonywanej co najmniej raz na 5 lat.",
    },
    {
      label: "Co obejmuje",
      value: "Panele, falownik, DC/AC i zabezpieczenia",
      description:
        "Kontrola dotyczy nie tylko modułów, ale też połączeń, złączy, falownika, zabezpieczeń i współpracy instalacji PV z budynkiem.",
    },
    {
      label: "Kiedy szybciej",
      value: "Po burzy, gradobiciu lub spadku uzysków",
      description:
        "Wcześniejszy przegląd warto zlecić także po rozbudowie systemu, przed końcem gwarancji i wtedy, gdy falownik zgłasza błędy albo instalacja pracuje niestabilnie.",
    },
    {
      label: "Ile kosztuje",
      value: "Zależy od mocy instalacji i dostępu do dachu",
      description:
        "Prosta domowa instalacja jest wyceniana inaczej niż system firmowy lub układ z magazynem energii. Na cenę wpływa też zakres pomiarów i rodzaj raportu.",
    },
  ],
  faqTitle: "Najczęstsze pytania o przegląd instalacji fotowoltaicznej",
  sections: [
    {
      title: "Na czym polega przegląd instalacji fotowoltaicznej",
      paragraphs: [
        `Przegląd instalacji fotowoltaicznej sprawdza, czy cały system PV działa bezpiecznie i czy nie traci wydajności przez usterki, które nie są widoczne w samej aplikacji użytkownika. Liczy się nie tylko produkcja energii, ale też stan paneli, połączeń, falownika i zabezpieczeń.`,
        `To usługa przydatna po montażu, po kilku latach eksploatacji, przed końcem gwarancji, po burzy albo wtedy, gdy uzysk spada bez jasnej przyczyny. W takich sytuacjach sama obserwacja falownika zwykle nie wystarcza do rzetelnej oceny stanu instalacji.`,
        `Dobrze wykonany przegląd powinien odpowiedzieć, czy instalacja nadaje się do dalszej eksploatacji, które elementy wymagają interwencji i czy problem dotyczy modułów, strony DC, strony AC czy współpracy z rozdzielnią budynku.`,
      ],
    },
    {
      title: "Co obejmuje kontrola paneli, falownika i zabezpieczeń",
      paragraphs: [
        `Kontrola obejmuje ocenę modułów, mocowań, przewodów, złączy, stanu okablowania DC i AC oraz zabezpieczeń. Sprawdza się też, czy nie ma śladów uszkodzeń mechanicznych, przegrzewania, poluzowanych połączeń lub oznak degradacji elementów pracujących na dachu i w obrębie falownika.`,
        `Falownik jest jednym z kluczowych punktów całego systemu, dlatego w czasie przeglądu analizuje się historię błędów, warunki chłodzenia, komunikaty alarmowe i podstawowe parametry pracy. To właśnie on często jako pierwszy pokazuje, że z instalacją dzieje się coś niepokojącego.`,
        `W zależności od zakresu zlecenia kontrola może obejmować też pomiary po stronie DC i AC oraz ocenę współpracy PV z rozdzielnią budynku. Sama produkcja energii nie wystarcza do oceny bezpieczeństwa, jeśli system ma błędne zabezpieczenia albo niestabilne połączenia.`,
      ],
    },
    {
      title: "Kiedy wykonać przegląd PV i jak łączyć go z magazynem energii",
      paragraphs: [
        `Regularny przegląd warto wykonywać zwykle co 1-2 lata, a obowiązkową kontrolę instalacji elektrycznej traktować jako minimum prawne. Dodatkową wizytę dobrze zlecić po gradobiciu, silnej burzy, zauważalnym spadku uzysków, rozbudowie systemu albo przed końcem gwarancji producenta.`,
        `Jeśli instalacja współpracuje z magazynem energii, ocena nie powinna kończyć się na samych panelach. Trzeba sprawdzić także komunikację urządzeń, konfigurację falownika, logikę pracy całego układu i to, czy zabezpieczenia są dopasowane do obecnego sposobu użytkowania instalacji.`,
        `To szczególnie ważne po zmianie falownika, dołożeniu baterii, rozbudowie mocy PV albo montażu nowych odbiorów dużej mocy. W takich sytuacjach problem nie zawsze leży w samych modułach, ale w integracji całego systemu.`,
      ],
    },
    {
      title: "Cena przeglądu instalacji fotowoltaicznej",
      paragraphs: [
        `Cena przeglądu instalacji fotowoltaicznej zależy od wielkości systemu, rodzaju dachu, dostępności modułów, zakresu pomiarów i tego, czy kontrola obejmuje wyłącznie oględziny, czy także analizę falownika oraz zabezpieczeń.`,
        `Na koszt wpływa również stopień złożoności układu. Instalacja domowa bez magazynu energii jest wyceniana inaczej niż system firmowy albo układ współpracujący z baterią, rozbudowaną rozdzielnią i dodatkowymi zabezpieczeniami.`,
        `Porównując oferty, warto sprawdzić, czy cena obejmuje raport, ocenę falownika, weryfikację zabezpieczeń i wnioski po kontroli. Lokalny rynek oraz dojazd mają znaczenie, ale o realnej wartości usługi decyduje przede wszystkim to, czy dostajesz pełną diagnozę całego systemu PV.`,
      ],
    },
  ],
  scopeTitle: "Zakres usług przeglądu instalacji fotowoltaicznej",
  scopeItems: [
    "Inspekcja wizualna paneli",
    "Kontrola falownika",
    "Ocena okablowania DC/AC",
    "Weryfikacja zabezpieczeń",
    "Sprawdzenie złączy i połączeń",
    "Ocena konstrukcji montażowej",
    "Analiza błędów i alarmów",
    "Raport z przeglądu",
  ],
  seo: {
    title: "Przegląd instalacji fotowoltaicznej: cena, falownik i pomiary PV",
    description:
      "Zamów przegląd instalacji fotowoltaicznej i sprawdź stan paneli, falownika, zabezpieczeń i magazynu energii. Zobacz, kiedy wykonać kontrolę PV i co wpływa na cenę.",
  },
};
